/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderInfoForInboundPictureParcelInfoVo
 */
export interface OrderInfoForInboundPictureParcelInfoVo {
    /**
     * 快递单id
     * @type {number}
     * @memberof OrderInfoForInboundPictureParcelInfoVo
     */
    parcelId?: number;
    /**
     * 快递单号
     * @type {string}
     * @memberof OrderInfoForInboundPictureParcelInfoVo
     */
    trackingNumber?: string;
    /**
     * 快递单状态
     * @type {number}
     * @memberof OrderInfoForInboundPictureParcelInfoVo
     */
    parcelStatus?: number;
    /**
     * 快递单状态名称
     * @type {string}
     * @memberof OrderInfoForInboundPictureParcelInfoVo
     */
    parcelStatusName?: string;
}

/**
 * Check if a given object implements the OrderInfoForInboundPictureParcelInfoVo interface.
 */
export function instanceOfOrderInfoForInboundPictureParcelInfoVo(value: object): value is OrderInfoForInboundPictureParcelInfoVo {
    return true;
}

export function OrderInfoForInboundPictureParcelInfoVoFromJSON(json: any): OrderInfoForInboundPictureParcelInfoVo {
    return OrderInfoForInboundPictureParcelInfoVoFromJSONTyped(json, false);
}

export function OrderInfoForInboundPictureParcelInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForInboundPictureParcelInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'parcelId': json['parcelId'] == null ? undefined : json['parcelId'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'parcelStatus': json['parcelStatus'] == null ? undefined : json['parcelStatus'],
        'parcelStatusName': json['parcelStatusName'] == null ? undefined : json['parcelStatusName'],
    };
}

export function OrderInfoForInboundPictureParcelInfoVoToJSON(json: any): OrderInfoForInboundPictureParcelInfoVo {
    return OrderInfoForInboundPictureParcelInfoVoToJSONTyped(json, false);
}

export function OrderInfoForInboundPictureParcelInfoVoToJSONTyped(value?: OrderInfoForInboundPictureParcelInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parcelId': value['parcelId'],
        'trackingNumber': value['trackingNumber'],
        'parcelStatus': value['parcelStatus'],
        'parcelStatusName': value['parcelStatusName'],
    };
}

